import getRequest from '../utils/getRequest.js';
import Cookies from 'js-cookie'  
import {logout} from '../io/api.js'
import {getCookieInfo,clearAllCookie} from './getCookie.js' 
let token = getRequest(window.location.search)['token'] || '';
let loginType=localStorage.getItem('loginType')||Cookies.get('loginType')||'';
import {axiosTimer } from './axiosTimer.js'
import Vue from 'vue'
import { Message } from 'element-ui'; 
import axios from '../assets/js/axios.config.js';
Vue.prototype.$message = Message; 

let cancelTokens =[]; // 存储所有请求的 CancelToken
export const requestInter = (fetch) => {
    fetch.interceptors.request.use(function (config) {
        if(loginType){
            config.headers["X-Login-T"] = loginType;
        }
        config.headers["userfrom"] = 'tcmkb'
        token =  localStorage.getItem('token') ||getCookieInfo('access_token')||'';
        let refreshToken=window.localStorage.getItem("refresh_token")||getCookieInfo('refresh_token')||''; 
        // 创建 CancelToken，并存储到数组中   
        config.cancelToken = new axios.CancelToken(cancel => {
            cancelTokens.push(cancel);
        });
        
        if(token){ 
            config.headers["Authorization"] = 'bearer' +token ; 
            if(refreshToken){
                axiosTimer(refreshToken)
            }
        } 
        
         let $loadingBox = document.querySelector('.loading-box');
         $loadingBox && ($loadingBox.style.display = 'flex');
        
         return config;
     }, function (error) {
        console.log(error,'==request.use.err==')
        return Promise.reject(error);
     });
}
let isUnauthorized = false; // 标记是否已经触发 401 处理
export const responseInter = (fetch) => {
    fetch.interceptors.response.use(function (response) {
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');  
        //未登录的情况 
        if(response&&response.data&&response.data.code=='401'){
            // console.log(response.data.msg,"401") //其他页面路径不要用homePage
            // if(window.location.href.indexOf('home')!=-1){

            response.data.msg = response.data.msg=='未授权,请登录'?'您的账号已退出或已在其他地方登录':response.data.msg; 
            if(window.location.href==`${location.origin}/knowservePlatform/homePage`){ 
                
                return response
            }
            // Vue.prototype.$message.error(response.data.msg||'请求失败～');
            if(response.config.url!=('/info')){
                 Vue.prototype.$message({
                    message:response.data.msg||'请求失败～',
                    duration: 1500,
                    type: 'error',
                    onClose:()=>{ 
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        clearAllCookie();
                        window.localStorage.removeItem('refresh_token')
                        logout().then(res=>{
                            let data = res.data;
                            if(data&&data.code==0){
                                window.open(`${location.origin}/knowservePlatform/homePage`, "_self");				
                            }else{
                                Vue.prototype.$message.error(data.msg||'请求失败～');
                            }
                        })
                    }
                })
            }
           
            
        }   
        return response;
    }, function (error) {
        // 打印请求失败的接口信息
        console.log('请求失败接口:', error.config.url, '错误信息:', error.message);
        
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');

        if (error.response && error.response.data && error.response.data.code == '101') {
            window.location.href = error.response.data.data.loginUrl;
        }
        
        return Promise.resolve(error.response);
        // return Promise.reject(error);
    });
}
